import { AcademicCalendarView } from '@/features/institute/calendar/components/AcademicCalendarView';
import { calendarApi } from '@/features/institute/calendar/api/calendar.api';
import { useApiQuery } from '@/hooks/useApiQuery';

/**
 * The academic calendar, as a teacher reads it.
 *
 * The office's own planner (`GET /institute/calendar`), drawn by the office's
 * own `AcademicCalendarView`, read-only. A teacher cannot change the calendar,
 * so the server narrows it to what was addressed to everyone or to teachers —
 * the rule the notice board follows — and an exam week, a staff meeting and a
 * holiday read the same here as on the office's screen.
 */
export function TeacherCalendarPage() {
  const { data, isLoading, error, refetch } = useApiQuery(() => calendarApi.list(), []);

  return (
    <AcademicCalendarView
      data={data}
      isLoading={isLoading}
      error={error}
      onRetry={refetch}
      title="Academic calendar"
      description="Exams, events, meetings and holidays for your school this session."
      emptyDescription="Your school has not put anything on this session's calendar for teachers yet. Exam weeks, meetings and holidays appear here as soon as the school office adds them."
    />
  );
}
